import { render, staticRenderFns } from "./InvoicePrintDetails_Invoice.vue?vue&type=template&id=4ad0b866&"
import script from "./InvoicePrintDetails_Invoice.vue?vue&type=script&lang=js&"
export * from "./InvoicePrintDetails_Invoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports